import React, { useEffect, useState } from 'react';
import ModulePermissionSelector from './ModulePermissionSelector';
import { moduleService } from '../services/moduleService';
import './ModulePermissionDialog.css';

const ModulePermissionDialog = ({ employee, initialPermissions, onCancel, onSubmit }) => {
  const [modules, setModules] = useState([]);
  const [permissions, setPermissions] = useState(initialPermissions || {});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadModules = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await moduleService.getModulesWithSubModules();
        setModules(res.data || res);
      } catch (e) {
        console.error('Error loading modules', e);
        setError("Erreur lors du chargement des modules");
      } finally {
        setLoading(false);
      }
    };
    loadModules();
  }, []);

  const handleConfirm = () => {
    const list = Object.values(permissions || {});
    onSubmit(list);
  };

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content module-permission-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Permissions des modules pour {employee?.nom} {employee?.prenom}</h2>
          <button className="close-button" onClick={onCancel}>×</button>
        </div>
        <div className="modal-body">
          {error && <div className="error-banner">{error}</div>}
          {loading ? (
            <div>Chargement des modules...</div>
          ) : (
            <ModulePermissionSelector
              modules={modules}
              value={permissions}
              onChange={setPermissions}
            />
          )}
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Annuler
          </button>
          <button type="button" className="btn btn-primary" onClick={handleConfirm}>
            Enregistrer les accès
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModulePermissionDialog;


